// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2lM9B","alertIcon":"ConfirmModal_alertIcon__1-NjE"};